var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientInBathroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.9,21.3H9.5v-13c0-1.1,0.9-2,2-2c0,0.1,0,0.1,0,0.2c0,0.3,0.1,0.6,0.4,0.8L12,7.6c-0.7,1.1-0.6,2.5,0.3,3.3l0.1,0.1 l-0.5,0.5l0.8,0.8l0.5-0.5h0l5.1-5.1l0,0l0.5-0.5L18,5.5L17.5,6l-0.1-0.1c-0.5-0.5-1.1-0.7-1.8-0.7c-0.5,0-1.1,0.2-1.5,0.4 l-0.2-0.2c-0.4-0.4-1.2-0.5-1.6-0.1h-0.7c-1.7,0-3.1,1.4-3.1,3.1v13H7.1c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h1.3v0h23.2v0h1.3 c0.7,0,1.3-0.6,1.3-1.3S33.6,21.3,32.9,21.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3,
    y: 9.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.6009 15.0474)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 16.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.3234 21.6192)",
    width: 1.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 14.1,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -4.4863 19.5929)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 11.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.5432 17.3221)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.6,
    y: 16.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.1686 20.0843)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 11.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.284 15.535)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 18.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.0061 22.1064)",
    width: 1.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 14.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.2263 17.8097)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.6,
    y: 11.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.5935 18.6037)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 9.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.6513 16.3291)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 13.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.5358 20.8787)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 16,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.3733 22.9007)",
    width: 1.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 14,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.7957 22.6664)",
    width: 1.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.9,
    y: 7.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.332130e-02 16.0942)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 11.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.9581 20.6439)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 9.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1.0158 18.3691)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 14.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.0709 16.2751)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 12.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.1288 14.0002)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 16.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.0131 18.5498)",
    width: 1.1,
    height: 2.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.4,
    y: 19,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.8508 20.5719)",
    width: 1.1,
    height: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,25.6c0,3.2,1.9,5.9,4.5,7.2c-0.2,0.7-0.8,1.2-1.5,1.2c-0.1,0-0.3,0-0.4-0.1l-0.3,1c0.2,0.1,0.5,0.1,0.7,0.1 c1.2,0,2.2-0.8,2.6-1.9c0.7,0.2,1.5,0.4,2.3,0.4h7.5c0.8,0,1.6-0.1,2.3-0.3c0.3,1.1,1.4,1.9,2.5,1.9c0.2,0,0.5,0,0.7-0.1l-0.3-1 c-0.1,0-0.3,0.1-0.4,0.1c-0.7,0-1.4-0.5-1.5-1.2c2.7-1.3,4.6-4,4.6-7.2v-0.6H8.4V25.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInBathroom);
export default __webpack_public_path__ + "static/media/client-in-bathroom.f99e3ccdf5950a5ede33f136da23fd49.svg";
export { ForwardRef as ReactComponent };